import { Component, HostListener, inject, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterModule } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { TranslatePipe } from '@ngx-translate/core';
import { StorageService } from '../../../services/base/storage.service';
import { ThemeService, ThemeMode } from '../../../services/base/theme.service';
import { TranslationService } from '../../../services/base/translation.service';

@Component({
  selector: 'app-navbar',
  standalone: true,
  imports: [CommonModule, RouterModule, MatIconModule, TranslatePipe],
  templateUrl: './navbar.html',
  styleUrls: ['./navbar.css'],
})
export class NavbarComponent {
  private router = inject(Router);
  private storage = inject(StorageService);
  themeService = inject(ThemeService);
  translationService = inject(TranslationService);

  isUserMenuOpen = signal(false);
  isMobileMenuOpen = signal(false);
  userName = this.storage.get('username') || 'Usuario';

  setTheme(mode: ThemeMode): void {
    const next: Record<ThemeMode, ThemeMode> = {
      dark: 'light',
      light: 'system',
      system: 'dark',
    };
    if (this.themeService.mode() === mode) {
      const nextMode = next[mode];
      this.themeService.setMode(nextMode);
    } else {
      this.themeService.setMode(mode);
    }
  }

  toggleLanguage(): void {
    this.translationService.toggle();
  }

  toggleUserMenu(event: Event): void {
    event.stopPropagation();
    this.isUserMenuOpen.update(v => !v);
  }

  closeUserMenu(): void {
    this.isUserMenuOpen.set(false);
  }

  onUserMenuClick(event: Event): void {
    event.stopPropagation();
  }

  logout(): void {
    this.storage.remove('token');
    this.storage.remove('Username');
    this.router.navigate(['/login']);
  }

  @HostListener('document:click')
  onDocumentClick(): void {
    this.closeUserMenu();
  }

  toggleMobileMenu(): void {
    this.isMobileMenuOpen.update(v => !v);
  }

  closeMobileMenu(): void {
    this.isMobileMenuOpen.set(false);
  }
}
